import { render, staticRenderFns } from "./TreeSearchResult.vue?vue&type=template&id=5130df6d&"
import script from "./TreeSearchResult.vue?vue&type=script&lang=js&"
export * from "./TreeSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports